<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="afflictionTestForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                afflictionTestForm: () => import('../forms/AfflictionTestForm'),
                headers: [
                    { text: 'Inspection', value: 'inspectionId', table: 'inspections', form: () => import('../forms/InspectionForm') },
                    { text: 'Pest/Disease', value: 'afflictionId', table: 'afflictions', form: () => import('../forms/AfflictionForm') },
                    { text: 'Pest/Disease Test Method', value: 'afflictionTestMethod', format: this.formatEnum },
                    { text: 'Pest/Disease Test Result', value: 'afflictionTestResult', format: this.formatEnum },
                    { text: 'Report File', value: 'reportFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    afflictions: [],
                    inspections: [],
                    files: [],
                    items: []
                },
                sorting: [
                    { column: "inspectionId", direction: "ascending" },
                    { column: "afflictionId", direction: "ascending" },
                ],
                itemsField: 'afflictionTests',
                editPageName: 'afflictionTest',
                apiMethod: 'AfflictionTests',
                claimName: 'AfflictionTests',
                formTitle: 'Pest/Disease Test',
                excelTitle: 'Pest/Disease Tests',
                hasEditPage: false,
            }
        },
    };
</script>
